// Get all footer blocks
const footerBlocks = document.querySelectorAll('.footer-block');

// Function to toggle details content
function toggleDetailsContent(detailsContent) {
  // Check if screen size is mobile
  if (window.innerWidth < 750) {
    // Toggle details content
    detailsContent.classList.toggle('hidden');
    // Toggle arrow icon (optional)
    // heading.querySelector('.arrow-icon').classList.toggle('rotate-180');
  }
}

// Function to handle mobile visibility for details content
function handleMobileVisibility(detailsContent, footerBlock) {
  // Always show content on desktop
  if (window.innerWidth >= 750) {
    detailsContent.classList.remove('hidden');
  } else {
    // On mobile, always show link lists, hide others by default
    if (footerBlock.classList.contains('footer-block--menu')) {
      // This is a link list block - always show it
      detailsContent.classList.remove('hidden');
    } else {
      // This is not a link list - hide by default on mobile
      detailsContent.classList.add('hidden');
    }
  }
}

// Set up each footer block
footerBlocks.forEach((footerBlock) => {
  const heading = footerBlock.querySelector('.footer-block__heading');
  const detailsContent = footerBlock.querySelector('.footer-block__details-content:not(.footer-block-image)');

  // Only proceed if both heading and details content exist
  if (heading && detailsContent) {
    // Add click event listener to heading only for non-menu blocks
    if (!footerBlock.classList.contains('footer-block--menu')) {
      heading.addEventListener('click', () => {
        toggleDetailsContent(detailsContent);
      });
    }

    // Set initial mobile visibility
    handleMobileVisibility(detailsContent, footerBlock);
  }
});

// Add event listener to window resize
window.addEventListener('resize', () => {
  footerBlocks.forEach((footerBlock) => {
    const detailsContent = footerBlock.querySelector('.footer-block__details-content:not(.footer-block-image)');

    if (detailsContent) {
      handleMobileVisibility(detailsContent, footerBlock);
    }
  });
});
